import Vue from 'vue'; 
import Vuex from 'vuex';

import {init as initAxios} from '@/helpers/axios/index';
import _auth from '@/helpers/api/auth/index';   
import _orders from '@/helpers/api/orders/index';   
import _client from '@/helpers/api/client/index'; 
import _services from '@/helpers/api/services/index';
import _address from '@/helpers/api/address/index';
import _public from '@/helpers/api/_public/index';
import _chat from '@/helpers/api/chat/index';
import _materials from '@/helpers/api/materials/index';

import '@/helpers/config/index';

export default { 
    repositories: init()
} 

function inject(key, data, object) { 
    Object.defineProperty(object, key, {
        get () {
          return data;
        },
        set(v) {  
            return data = v;
        }
    });
}
 
function appendToVue(repositories) {
    inject('$api', repositories,  Vue.prototype);
    inject('$api', repositories,  Vuex.Store.prototype);
}
 
function init() {  
    const axios = initAxios(); 
    
    const auth = _auth(axios);
    const orders = _orders(axios);
    const client = _client(axios);
    const services = _services(axios);
    const address = _address(axios);
    const $public = _public(axios);
    const chat = _chat(axios);
    const materials = _materials(axios);

    const repositories = {
        auth,
        orders,
        client,
        services,
        address,
        public: $public,
        chat,
        materials
    };

    appendToVue(repositories);

    return repositories;
}
